module.exports = __webpack_public_path__ + "assets/cakephp.37f7ed14.svg";